import { bemCN } from "../../config/bem-classname";
import "./offline-page.scss";

const offlinePageCn = bemCN("offline-page");

export const OfflinePage = () => {
  return (
    <div className={offlinePageCn()}>
    </div>
  );
};
